import React from 'react';
import cx from 'classnames';
import { bool, func, node, string, object } from 'prop-types';

import useStyles from 'hooks/useStyles';
import FullMask from 'components/FullMask';
import { CloseIcon } from 'components/Icon';

import styles from './BaseModal.scss';

export default function BaseModal({
  onClose,
  closable,
  title,
  children,
  buttons,
  classNameMap,
  isScrollable,
  isFullMode,
}) {
  useStyles(styles);
  const hasTitleOrClose = title || closable;

  return (
    <FullMask onClickShadow={onClose}>
      <div
        className={cx(
          styles.root,
          { [styles.fullModeRoot]: isFullMode },
          classNameMap.root,
        )}
      >
        <div className={styles.wrapper}>
          {hasTitleOrClose && (
            <header
              className={cx(styles.title, {
                [styles.hasClose]: closable,
              })}
            >
              {closable && (
                <CloseIcon className={styles.closeIcon} onClick={onClose} />
              )}
              {!!title && <h5>{title}</h5>}
            </header>
          )}
          <div
            className={cx(styles.content, classNameMap.content, {
              [styles.contentScrollable]: isScrollable,
              [styles.contentFullMode]: isFullMode,
            })}
          >
            {children}
            {buttons && <div className={styles.buttonWrapper}>{buttons}</div>}
          </div>
        </div>
      </div>
    </FullMask>
  );
}

BaseModal.propTypes = {
  children: node.isRequired,
  buttons: node,
  onClose: func,
  title: string,
  classNameMap: object,
  closable: bool,
  isFullMode: bool,
  isScrollable: bool,
};

BaseModal.defaultProps = {
  onClose: undefined,
  title: undefined,
  buttons: undefined,
  closable: false,
  classNameMap: {},
  isFullMode: true,
  isScrollable: false,
};
